import { EmptyStateIcons, Icons, Table } from '@silverfort/sf-components';
import React, { FC, useRef } from 'react';
import { useColumns } from './useColumns';
import { SortDirection } from '@silverfort/sf-components/dist/Table/interface';
import { ListItemProps } from '@silverfort/sf-components/dist/ListItem';
import { Resource } from '../../../types/Resource';
import { useActiveDirectoryAccessContext } from '../../../context';
import useGetRefSize from '../../../../../hooks/useGetRefSize';

type ResourcesTableProps = {
    loading: boolean;
    onResourceSelect: (resource: Resource) => void;
    onScrollEnd?: () => void;
    onSort?: (field: keyof Resource, direction: SortDirection) => void;
    onUpdateResourceStaleSettings: (resource?: Resource) => void;
    outerHeight?: number;
    resources: Array<Resource>;
};

const ResourcesTable: FC<ResourcesTableProps> = ({
    loading,
    onResourceSelect,
    onScrollEnd,
    onSort,
    onUpdateResourceStaleSettings,
    outerHeight,
    resources
}) => {
    const { hasAccessIntelligenceEditorRole } = useActiveDirectoryAccessContext();

    const tableRef = useRef(null);
    const { height } = useGetRefSize(tableRef);
    const columns = useColumns(onResourceSelect);

    const rowMenuItems: Array<ListItemProps<Resource>> = [
        {
            IconLeft: Icons.StaleUser,
            disabled: !hasAccessIntelligenceEditorRole,
            onClick: onUpdateResourceStaleSettings,
            title: 'Stale access since'
        }
    ];

    return (
        <div ref={tableRef} className="h-full w-full">
            <Table
                EmptyStateProps={{
                    className: 'w-full h-full',
                    icon: EmptyStateIcons.NoItems,
                    title: 'There are no Resources'
                }}
                bodyHeight={outerHeight || (height && height - 50)}
                columns={columns}
                loading={loading}
                onScrollEnd={onScrollEnd}
                onSortChange={onSort}
                rows={resources}
                tableContainerClassName={`w-full h-full flex flex-col`}
                menuItems={rowMenuItems}
            />
        </div>
    );
};

export default ResourcesTable;
